import React from 'react'
import PropTypes from 'prop-types'

import Button from '../../Button'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSlidersH } from '@fortawesome/pro-solid-svg-icons'

const ManageFilters = (props) => {
  const { filterCount, onClick, text } = props

  return (
    <Button 
      buttonStyle="secondaryUtility" 
      icon={<FontAwesomeIcon icon={faSlidersH} />} 
      onClick={onClick} 
      size="medium"
    >
      {filterCount ? `Manage (${filterCount}) Filters` : text}
    </Button>
  )
}

ManageFilters.defaultProps = {
  text: 'Manage Filters',
}

ManageFilters.propTypes = {
  filterCount: PropTypes.number,
  onClick: PropTypes.func.isRequired,
  text: PropTypes.string.isRequired,
}

export default ManageFilters
